// src/components/CustomSelect.jsx
// Dropdown custom que reemplaza <select> nativo con estilo del tema (teal/verde).
// Props idénticas a <select>: value, onChange, disabled, className, style + children (<option>s).

import React, { useState, useRef, useEffect } from 'react';

export default function CustomSelect({ value, onChange, disabled, className, style, children, placeholder }) {
  const [open, setOpen] = useState(false);
  const ref  = useRef(null);

  // Cerrar al clickear fuera
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  // Parsear <option> children en [{ value, label, disabled }]
  const options = React.Children.toArray(children)
    .filter(c => c.type === 'option')
    .map(c => ({
      value:    c.props.value ?? '',
      label:    c.props.children,
      disabled: c.props.disabled || false,
    }));

  const selected = options.find(o => String(o.value) === String(value));
  const displayLabel = selected ? selected.label : (placeholder || '—');

  const handleSelect = (opt) => {
    if (opt.disabled) return;
    onChange({ target: { value: opt.value } });
    setOpen(false);
  };

  const toggle = () => { if (!disabled) setOpen(o => !o); };

  return (
    <div
      ref={ref}
      className={`custom-select-wrap${className ? ' ' + className : ''}${disabled ? ' cs-disabled' : ''}`}
      style={{ position: 'relative', ...style }}
    >
      <button
        type="button"
        className="cs-trigger"
        onClick={toggle}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="cs-value">{displayLabel}</span>
        <i className={`bi bi-chevron-${open ? 'up' : 'down'} cs-arrow`} />
      </button>

      {open && (
        <ul className="cs-dropdown" role="listbox">
          {options.map((opt, i) => (
            <li
              key={i}
              role="option"
              aria-selected={String(opt.value) === String(value)}
              className={[
                'cs-option',
                String(opt.value) === String(value) ? 'cs-selected' : '',
                opt.disabled ? 'cs-option-disabled' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
